import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-youtube',
  shadow: false,
})
export class CmsIconYoutube {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {
    return (
      /*@ts-ignore*/
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 20 20"
        focusable="false"
        aria-hidden="true"
        fill-rule="evenodd"
        clip-rule="evenodd"
        width={this.dataWidth}
        height={this.dataHeight}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.582 5.18596C20 6.74583 20 9.99992 20 9.99992C20 9.99992 20 13.2542 19.582 14.8139C19.352 15.6742 18.6744 16.3522 17.8139 16.582C16.2542 17 9.99992 17 9.99992 17C9.99992 17 3.74581 17 2.18611 16.582C1.3256 16.3522 0.647981 15.6742 0.417994 14.8139C0 13.2542 0 9.99992 0 9.99992C0 9.99992 0 6.74583 0.417994 5.18596C0.647981 4.3256 1.3256 3.64782 2.18611 3.41783C3.74581 3 9.99992 3 9.99992 3C9.99992 3 16.2542 3 17.8139 3.41783C18.6744 3.64782 19.352 4.3256 19.582 5.18596ZM8.06684 12.8843L13.335 9.92107L8.06684 6.95757V12.8843Z"
          fill={this.dataFill}
        />
      </svg>
    );
  }
}
